<template>
    <div>
        <div
            ref="content"
            :class="[{ 'line-clamp-6 md:line-clamp-none' : !isOpen }]"
        >
            <slot />
        </div>

        <button
            v-if="isTruncated"
            class="flex md:hidden items-center bg-white text-deep-teal-700 py-2"
            @click="isOpen = !isOpen"
        >
            <ChevronUpIcon
                class="h-5 w-5 mr-2 transition-transform"
                :class="[isOpen ? 'rotate-0' : 'rotate-180']"
            />

            <span class="font-semibold text-base">
                <span v-if="!isOpen">{{ $t('components.showMore.more') }}</span>
                <span v-else>{{ $t('components.showMore.less') }}</span>
            </span>
        </button>
    </div>
</template>

<script setup>
import { ChevronUpIcon } from '@heroicons/vue/20/solid';
import { onMounted, ref } from 'vue';
import { useEventListener } from '@vueuse/core';

const breakpointTablet = ref(768);
const isOpen = ref(false);
const isTruncated = ref(false);
const content = ref(null);

onMounted(() => {
    checkBreakpoint();
    checkTruncated();

    useEventListener(globalThis, 'resize', () => checkBreakpoint());
    useEventListener(globalThis, 'resize', () => checkTruncated());
});

const checkBreakpoint = () => {
    if (document.body.clientWidth >= breakpointTablet.value) {
        isOpen.value ||= true;
    } else {
        isOpen.value &&= false;
    }
};

const checkTruncated = function () {
    isTruncated.value = content.value.scrollHeight > content.value.clientHeight || content.value.scrollWidth > content.value.clientWidth;
};
</script>
